const prefix = {
    dashboard: 'dashboard/',
    preference: 'preference/',
    plan: 'plan/',
    overview: 'overview/',
    route: 'route/',
    siteOverview: 'siteOverview/',
    vesselOverview: 'vesselOverview',
}

export const DashboardSetting = {
    SECTION_FILTER: prefix.dashboard + 'sectionFilter',
    FACTORIES: prefix.dashboard + 'factories',
    PRODUCT_AREA: prefix.dashboard + 'productionArea',
    PRODUCT_AREAS: prefix.dashboard + 'productionAreas',
    ACTIVE_SITE: prefix.dashboard + 'activeSite',
    DISEASED_ZONE: prefix.dashboard + 'diseasedZone',
    VESSELS: prefix.dashboard + 'vessels',
    MAP_STYLE: prefix.dashboard + 'mapStyle'
}


export const OverviewSetting = {
    VESSEL_FILTER: prefix.overview + 'vesselFilter',
    CREW_VESSEL_FILTER: prefix.overview + 'crewVesselFilter',
    WELLBOAT_FILTER: prefix.overview + 'wellboatFilter',
    WEEK_PER_PAGE: prefix.overview + 'weekPerPage',
    VESSEL_ORDER: prefix.overview + 'vesselOrder',
    SITE_ORDER: prefix.overview + 'siteOrder',
}

export const SiteOverviewSetting = {
    UNITS_REGIONS_FILTER: prefix.siteOverview + "unitsRegionsFilter",
    UNITS_PROD_AREA_FILTER: prefix.siteOverview + "unitsProdAreaFilter",
    UNITS_ACTIVE_UNIT_FILTER: prefix.siteOverview + "unitsActiveUnitFilter",
    SUMMARY_LICE_THRESHOLD: prefix.siteOverview + "lice_threshold",
    SUMMARY_UNIT_DENSITY: prefix.siteOverview + "unit_density",
    SUMMARY_SITE_LIMIT_PERCENT: prefix.siteOverview + "site_limit_percent",
    SUMMARY_HARVEST_AVG: prefix.siteOverview + "harvest_avg",
    SUMMARY_MORTALITY_THRESHOLD: prefix.siteOverview + "mortality_threshold",
}

export const PreferenceSetting = {
    VIEW_MODE: prefix.preference + 'viewMode',
    FACTORIES_TIME: 'factoriesTime',
    SITES_TIME: 'sitesTime',
    PRIORITY_TIME: 'priorityTime',
    SHOW_CERTAINTY: 'isCertainty',
    AUTO_PLAN: 'autoPlanConfig',
    CUSTOMIZE_HARVEST: 'customizeHarvest',
    THEME_COLOR: prefix.preference + 'themeColor'
}

export const PlanSetting = {
    GROUP_BY_WEEK: 'planGroupByWeek',
    GROUP_BY_UNIT: 'planGroupByUnit',
    SHOW_STHP_EMPTY: 'planShowAllPlanned',
    STHP_PRIOR_WEEKS: prefix.plan + 'sthp/priorWeeks',
    BIOLOGY_TAB: 'planStoreTabs',
    BIOLOGY_LICE_SORT: prefix.plan + 'biologyLiceSort',
    LOCATION_PROD_AREA: prefix.plan + 'locationProdAreaFilter',
    SERVICE_REQUESTS_STATUS: prefix.plan + 'serviceRequestsStatus',
    BIOLOGY_SITE: 'biologySiteFilter',
    BIOLOGY_PROD_AREA: 'biologyProdAreaFilter',
    BIOLOGY_AVG_WEIGHT: 'smoltProdAreaFilter',
    STHP_SITE_FILTER: 'plannedSiteFilter',
    STHP_FACTORY_FILTER: 'plannedFactoryFilter',
    STHP_PROD_AREA_FILTER: 'plannedProdAreaFilter',

    SMOLT_SITE: 'smoltFilter',
    SMOLT_PROD_AREA: 'smoltProdAreaFilter',
    SMOLT_LICE_SORT: prefix.plan + 'smoltLiceSort',
    VESSEL_FILTER: 'planVessels',

    CALENDAR_VIEW: prefix.plan + 'calendarView',
    CALENDAR_VIEW_SIZE: prefix.plan + 'calendarViewSize',
}

export const RouteSetting = {
    AUTO_ROUTE: prefix.route + 'autoRoute'
}

export const GlobalSetting = {
    WEATHER: 'weatherFilter',
    MAP_STYLE: 'googleMapStyle',
    MAIL: 'mail'
}

export const VesselSetting = {
    VESSEL_FILTER: prefix.vesselOverview + 'vesselFilter'
}
